import React from 'react';

const MatchingAnswersIconNotActive = () => {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 8.25C0 3.83172 3.58172 0.25 8 0.25H24C28.4183 0.25 32 3.83172 32 8.25V23.75C32 28.1683 28.4183 31.75 24 31.75H8C3.58172 31.75 0 28.1683 0 23.75V8.25Z" fill="#E2E2E8" />
            <path d="M8.5 16.75L13 21.25L23.5 10.75" stroke="url(#paint0_linear_4611_21019)"
                strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
            <defs>
                <linearGradient id="paint0_linear_4611_21019" x1="7.44681" y1="10.75" x2="24.0119" y2="11.532" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#32A6AE" />
                    <stop offset="1" stopColor="#00BBA7" />
                </linearGradient>
            </defs>
        </svg>
    )
}

export default MatchingAnswersIconNotActive;